<!-- <div class="row">
  <div class="col-12 d-flex justify-content-end">
    <div class="d-flex">
      <mat-checkbox color="primary" class="mx-2 font-white" (change)="UpdateAllMenus($event, 'canAdd', selectedMenu)">IsCreate</mat-checkbox>
      <mat-checkbox color="primary" class="mx-2 font-white" (change)="UpdateAllMenus($event, 'canEdit', selectedMenu)">IsUpdate</mat-checkbox>
      <mat-checkbox color="primary" class="mx-2 font-white" (change)="UpdateAllMenus($event, 'canDelete', selectedMenu)">IsDelete</mat-checkbox>
    </div>
  </div>
  <div class="col-12">
    <div style="height: 430px; overflow-y: auto; overflow-x: hidden " class="p-2 font-white">
      @if (selectedMenu?.length) { @for (item of selectedMenu; track item) {
      <ng-container [ngTemplateOutlet]="NavigationItems" [ngTemplateOutletContext]="{ item: item }"> </ng-container>
      } }
    </div>
  </div>
</div>
<ng-template #NavigationItems let-NavItem="item">
  <div class="w-100 d-flex align-items-center">
    <div class="d-flex justify-content-between align-items-center pe-3 w-100 rowheight mt-2 --border-radius-5 --border-primary">
      <div class="d-flex align-items-center px-3">
        <span>{{ NavItem?.MenuName }}</span>
        <span class="ms-2 --text-primary">{{ NavItem?.RouterPath }}</span>
      </div>
      <div class="d-flex justify-content-end">
        <div class="d-flex">
          <mat-checkbox class="mx-3 font-white" (change)="UpdateAllMenus($event, 'canAdd', [NavItem])" [(ngModel)]="NavItem.canAdd"> </mat-checkbox>
          <mat-checkbox class="mx-3 font-white" (change)="UpdateAllMenus($event, 'canEdit', [NavItem])" [(ngModel)]="NavItem.canEdit"></mat-checkbox>
          <mat-checkbox class="mx-3 font-white" (change)="UpdateAllMenus($event, 'canDelete', [NavItem])" [(ngModel)]="NavItem.canDelete"></mat-checkbox>
        </div>
      </div>
    </div>
  </div>
 @for (child of NavItem?.ChildList; track child) {
  <div class="ps-4">
    <ng-container [ngTemplateOutlet]="NavigationItems" [ngTemplateOutletContext]="{ item: child }"> </ng-container>
  </div>
  }
</ng-template> -->

<div class="row">
  <div class="col-12 d-flex justify-content-end">
    <div class="d-flex gap-2">
      <label class="custom-checkbox">
        <input type="checkbox" (change)="UpdateAllMenus($event, 'canAdd', selectedMenu)" />
        <span class="checkmark"></span>
      </label>
      <div class="font-white fs-14">IsCreate</div>

      <label class="custom-checkbox">
        <input type="checkbox" (change)="UpdateAllMenus($event, 'canEdit', selectedMenu)" />
        <span class="checkmark"></span>
      </label>
      <div class="font-white fs-14">IsUpdate</div>

      <label class="custom-checkbox">
        <input type="checkbox" (change)="UpdateAllMenus($event, 'canDelete', selectedMenu)" />
        <span class="checkmark"></span>
      </label>
      <div class="font-white fs-14">IsDelete</div>
    </div>
  </div>

  <div class="col-12">
    <div style="height: 430px; overflow-y: auto; overflow-x: hidden" class="p-2 font-white">
      @if (selectedMenu?.length) { @for (item of selectedMenu; track item) {
      <ng-container [ngTemplateOutlet]="NavigationItems" [ngTemplateOutletContext]="{ item: item }"></ng-container>
      } }
    </div>
  </div>
</div>

<ng-template #NavigationItems let-NavItem="item">
  <div class="w-100 d-flex align-items-start mt-2">

    <!-- Expand/Collapse Icon (OUTSIDE Border Box) -->
    <div class="d-flex align-items-center me-2" style="width: 24px; height: 100%">
      @if (NavItem?.ChildList?.length) {
        <button
          class="cursor-pointer bg-none border-0 p-0 m-0"
          (click)="toggleExpanded(NavItem)"
        >
          <div
            [innerHtml]="(isExpanded(NavItem) ? SVG_ICONS.UP_ICON('var(--font-color-white)',24,24) : SVG_ICONS.DOWN_ARROW()) | sanitizer : 'html'"
          ></div>
        </button>
      }
    </div>

    <!-- Border Box -->
    <div
      class="d-flex align-items-center justify-content-between flex-grow-1 w-100 p-2"
      style="border: 1px solid #adadad; border-radius: 6px"
    >
      <!-- Menu Name and Route Path -->
      <div class="d-flex px-2 gap-5">
        <div class="fw-semibold font-white">{{ NavItem?.MenuName }}</div>
      </div>
      <div class="font-white fs-16">{{ NavItem?.RouterPath }}</div>

      <!-- Checkboxes -->
      <div class="d-flex gap-3 pe-2">
        <label class="custom-checkbox">
          <input
            type="checkbox"
            [(ngModel)]="NavItem.canAdd"
            (change)="UpdateAllMenus($event, 'canAdd', [NavItem])"
          />
          <span class="checkmark"></span>
        </label>

        <label class="custom-checkbox">
          <input
            type="checkbox"
            [(ngModel)]="NavItem.canEdit"
            (change)="UpdateAllMenus($event, 'canEdit', [NavItem])"
          />
          <span class="checkmark"></span>
        </label>

        <label class="custom-checkbox">
          <input
            type="checkbox"
            [(ngModel)]="NavItem.canDelete"
            (change)="UpdateAllMenus($event, 'canDelete', [NavItem])"
          />
          <span class="checkmark"></span>
        </label>
      </div>
    </div>
  </div>

  <!-- Recursively Render Children -->
  @if (isExpanded(NavItem)) {
    @for (child of NavItem?.ChildList; track child) {
      <div class="ps-4">
        <ng-container
          [ngTemplateOutlet]="NavigationItems"
          [ngTemplateOutletContext]="{ item: child }"
        ></ng-container>
      </div>
    }
  }
</ng-template>


